import React from "react";
import ContentWrapper from "../components/ContentWrapper";
import Sidebar from "../components/Sidebar";
import VenuesTable from "../components/VenuesTable";
import { useAuth } from "../providers/auth";
import { Outlet } from "react-router-dom";
import Page from "../components/Page";

export default () => {
  const { session, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen">
        <div className="m-auto">
          <span className="loading loading-dots loading-lg"></span>
        </div>
      </div>
    );
  }

  if (!session) {
    return <div>Not logged in</div>;
  }

  return (
    <div className="drawer min-h-screen bg-base-200 lg:drawer-open">
      <input id="my-drawer" type="checkbox" className="drawer-toggle" />

      <ContentWrapper>
        <Outlet />
      </ContentWrapper>
      <Sidebar />
    </div>
  );
};
